import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ExternalLink } from "lucide-react";

export default function Xamarin() {
  return (
    <div>
      <section className="bg-[#f4f5f7] py-14 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <h1 className="text-4xl font-semibold text-slate-800">Xamarin</h1>
        </div>
      </section>

      <article className="max-w-5xl mx-auto px-6 lg:px-10 py-14">
        <Link
          to="/development-kits"
          className="inline-flex items-center gap-1 text-sm text-[#29abe2] hover:underline mb-8"
        >
          <ChevronLeft className="w-4 h-4" /> Back to Development Kits
        </Link>

        <section>
          <h2 className="text-2xl md:text-3xl font-semibold text-slate-800 mb-4">Overview</h2>
          <p className="text-slate-700 leading-relaxed text-[16px]">
            While Xamarin is not an officially supported platform, one of our customers has graciously packaged a
            version of the Android TappyBLE SDK for use on Xamarin and made it available{" "}
            <a
              href="https://gitlab.com/tylerjgarland/Xamarin.TappyBleSdk"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#29abe2] hover:underline inline-flex items-center gap-1"
            >
              here
              <ExternalLink className="w-3.5 h-3.5" />
            </a>
            .
          </p>
        </section>
      </article>
    </div>
  );
}
